/*
 *  [FRONTEND]
 * `FirebaseController.js`
 *
 *
 */
//------------------------------------------------------------------------------
// External dependencies
//------------------------------------------------------------------------------
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
// Logging
import logger from "./LoggerFrontend";

import AbstractFirebaseController from "./AbstractFirebaseController";
//------------------------------------------------------------------------------
// Class Blueprint
//------------------------------------------------------------------------------
const instance = Object.create(AbstractFirebaseController(firebase, logger));

export default instance;
